import { Fish } from "lucide-react";
import {
  FishboneParamsSchema,
  defaultFishboneParams,
  type FishboneParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { FishboneWidget } from "./Component.js";

export const fishboneDef: WidgetDef<FishboneParams> = {
  kind: "fishbone",
  label: "Fishbone (Ishikawa)",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 752, h: 324 },
  defaultParams: defaultFishboneParams,
  Component: FishboneWidget,
  storage: "sql",
  schema: FishboneParamsSchema,
  accent: "purple",
  icon: Fish,
  subtitle: "Causes grouped by category",
  dragLabel: "Fishbone",
  defaultRoster: true,
  category: "single",
  layout: { col: "full", row: 2, width: 752, height: 300 },
  expandable: true,
  renderFooter: (data) => {
    const totalCauses = data.branches.reduce((s, b) => s + b.causes.length, 0);
    return {
      left: `${data.branches.length} categories · ${totalCauses} causes`,
      right: `Effect: ${data.effect}`,
    };
  },
};

registerWidget(fishboneDef);
